const subpage = () => {
    
    new Waypoint({
        element: document.getElementById('subpage-header'),
        handler: function(direction) {
            if (window.innerWidth >= 768) {
                $(".navigation").toggleClass("scroll");
                $(".subpage-header").toggleClass("scroll");
            }
        },
        offset: '-10%'
    });

 }

 module.exports = {
    subpage,
 };